import script from "./LoadModelsMixin.vue?vue&type=script&lang=js"
export * from "./LoadModelsMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__